<template>
  <div class="follow-doctor">
    <p
      style="margin:10px; 0 0;fontSize:15px;"
      v-if="list.length==0"
    >暂无关注的医生</p>
    <div class="big-box">
      <div
        class="card-box"
        v-for="(item, index) in list"
        @click="goNext(item.doctorId)"
        :key="index"
      >
        <div class="cont-info">
          <div class="doctor-info">
            <div class="hospitalImg hp_center">
              <img
                v-if="item.avatar"
                :src="base_url + item.avatar"
                alt
              />
              <img
                v-else
                src="@/assets/default-img/doctor.png"
                alt
              />
            </div>
            <div class="doctor-title">
              <p style="margin:0;color:#333333;font-size: 18px;">{{ item.doctorName }} <span v-if="item.doctorLevel">{{item.doctorLevel}}</span> </p>
              <div style="color:#666;font-size: 16px;">{{ item.deptName }}</div>
              <span style="color:#999;font-size:14px">{{ item.hospitalName }}</span>

            </div>
          </div>
          <!-- lastVisitTime -->
          <div
            v-if="item.lastVisitTime"
            style="font-size:14px;padding-top:10px;color:rgb(153, 153, 153);"
          >最近就诊日期 {{item.lastVisitTime}}</div>
        </div>

        <a-popconfirm
          title="您确定取消关注吗？"
          ok-text="确定"
          cancel-text="取消"
          @confirm="confirm(item.doctorId)"
          v-if="item.type == 1"
        >
          <div
            class="cursor-point card-btn"
            @click.stop="clicka"
          >
            <a-icon
              class="active"
              style="margin-right:3px"
              type="heart"
              theme="filled"
            />
            <span>已关注</span>
          </div>
        </a-popconfirm>
        <div
          v-else
          class="card-btn"
        >
          <span>就诊过</span>
        </div>
      </div>
    </div>
    <div style="margin-top: 20px;padding-bottom:20px">
      <a-pagination
        v-if="list.length>0"
        show-quick-jumper
        :current="currPage"
        :total="totalCount"
        :defaultPageSize="form.pageSize"
        @change="onChange"
      />
    </div>
  </div>
</template>
<script>
import { getMyDoctPageList } from "@/api/user-center";
import { cancelFavorite } from "@/api/registered";
import { ls } from "@/utils/tool";
export default {
  data() {
    return {
      form: {
        pageNum: 1,
        pageSize: 8,
        memberId: "",
        recordId: "",
      },
      list: [],
      currPage: 1,
      totalCount: 1,
      sysUser: ls.get("sysUser"),
    };
  },
  created() {},
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      this.form.memberId = this.sysUser.id;
      this.form.recordId = this.sysUser.recordId;
      var res = await getMyDoctPageList(this.form);
      this.list = res.data.list || [];
      this.totalCount = res.data.totalCount;
      this.currPage = res.data.currPage;
      if (this.list.length == 0) {
        this.$message.success("暂无关注的医生");
      }
      console.log("res.data===", res.data);
    },
    async attention(docId) {
      var data = {
        memberId: this.sysUser.id,
        objectId: docId,
        objectType: 3,
      };
      var res;
      res = await cancelFavorite(data);
      console.log("res====", res);
      this.form.pageNum = 1;
      this.init();
    },
    onChange(pageNumber) {
      this.form.pageNum = pageNumber;
      this.init();
    },
    goNext(id) {
      this.$router.push("/registered/doctor/" + id + "/" + 0);
    },
    confirm(val) {
      this.attention(val);
    },
    clicka() {},
  },
};
</script>
<style lang="less" scoped>
.big-box {
  padding-top: 24px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding-bottom: 30px;
  padding-right: 3px;
  .next-page {
    margin-left: 550px;
    /deep/ li {
      width: 50px;
      height: 50px;
      line-height: 50px;
    }
  }
}
.card-box {
  cursor: pointer;
  width: 464px;
  height: 160px;
  background: #ffffff;
  box-shadow: 0px 0px 6px 0px rgba(69, 157, 247, 0.19);
  border-radius: 20px;
  padding: 14px 42px;
  position: relative;
  margin-bottom: 33px;
  .cont-info {
    padding: 25px 0;
    .doctor-info {
      display: flex;
      .hospitalImg {
        width: 62px;
        height: 62px;
        margin-right: 25px;
        overflow: hidden;
        border-radius: 50%;
        img {
          height: 62px;
        }
      }
      .doctor-title {
        display: flex;
        flex-direction: column;
        font-size: 16px;
        font-weight: 400;
        color: #666;
      }
    }
    .patient-box {
      display: flex;
      justify-content: space-between;
      font-size: 18px;
      margin-top: 8px;
      .patient-title {
        font-weight: 400;
        color: #333333;
      }
      .patient-name {
        color: #666;
      }
    }
  }
  .card-btn {
    width: 90px;
    height: 34px;
    background: #459df7;
    border-radius: 4px;
    text-align: center;
    line-height: 34px;
    color: #fff;
    font-size: 16px;
    position: absolute;
    top: 45px;
    right: 55px;

    .active {
      color: #d81e06;
    }
  }
}
</style>
